<script>
    import {clickOutside} from '../../lib/clickOutside.js';
    import Checkbox from "./Checkbox.svelte";

    export let options = [];
    export let value = [];
    export let placeholder = '';

    let name = '';
    let showDropdown = false;

    const handleEscapeKey = event => {
        if (event.key === 'Escape') {
            closeDropdown();
        }
    }

    const openDropdown = () => {
        showDropdown = true;
        document.addEventListener('keydown', handleEscapeKey);
    }

    const closeDropdown = () => {
        showDropdown = false;
        document.removeEventListener('keydown', handleEscapeKey);
    }

    const toggleDropdown = () => {
        if (showDropdown) {
            closeDropdown()
        } else {
            openDropdown()
        }
    }

    $: {
        value = [];
        name = '';
        options.map(item => {
            if (item.is_checked) {
                value.push(item.id);
                name += (name ? ", " : "") + item.name;
            }
        });
    }
</script>

<div class="dropdown-container" title="{ name }" use:clickOutside on:click_outside="{ closeDropdown }">
    <input type="text" class="form-control pointer" value="{ name }" on:click={ toggleDropdown } readonly {placeholder}>
    {#if showDropdown}
        <ul class="dropdown">
            {#if options && options.length}
                {#each options as item}
                    <li class="px-3 py-2">
                        <Checkbox label="{ item.name }" bind:checked="{ item.is_checked }"/>
                    </li>
                {/each}
            {:else}
                <li class="px-3 py-2">No options!</li>
            {/if}
        </ul>
    {/if}
</div>

